import React from "react";
import { Box, keyframes } from "@mui/material";
import basketballImg from "../../images/basketball.png";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }   
`;

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-25px); }
`;

const orbit = keyframes`
  0% { transform: rotate(0deg) translateX(70px) rotate(0deg); }
  100% { transform: rotate(360deg) translateX(70px) rotate(-360deg); }
`;

export default function NbaLoader() {
  const teamColors = [
    "#17408B",
    "#ED174C",
    "#FDB927",
    "#006BB6",
    "#1D428A",
    "#FFCD00",
  ];

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.8)",
        zIndex: 1500,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: 110,
          height: 110,
          backgroundImage: `url(${basketballImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "50%",
          animation: `${spin} 2s linear infinite, ${bounce} 1s ease-in-out infinite`,
          boxShadow: "0 0 50px rgba(255,165,0,0.9)",
          position: "relative",
          zIndex: 2,
        }}
      />

      {teamColors.map((color, i) => (
        <Box
          key={i}
          sx={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            backgroundColor: color,
            position: "absolute",
            top: "50%",
            left: "50%",
            animation: `${orbit} ${4 + i}s linear infinite`,
            transformOrigin: "-90px center",
            boxShadow: `0 0 10px ${color}`,
          }}
        />
      ))}
    </Box>
  );
}
